import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type DiscussionsSeparatorProps = ComponentProps<'hr'>;

export const DiscussionsSeparator = memo(({ className, ...restOfProps }: DiscussionsSeparatorProps) => {
  return <hr className={cn('h-px w-full ads:text-ads-gray-4 text-gray-5', className)} {...restOfProps} />;
});

DiscussionsSeparator.displayName = 'DiscussionsSeparator';
